import { __generator } from "tslib";
import { call, select } from 'redux-saga/effects';
import { getCurrentSubfolder, getCurrentGallection } from '../selectors';
import setGallectionCover from './setGallectionCover';
function makeDeviationCurrentGallectionCover(action) {
    var deviation, currentSubfolder, currentGallection, gallection;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                deviation = action.payload;
                return [4 /*yield*/, select(getCurrentSubfolder)];
            case 1:
                currentSubfolder = _a.sent();
                return [4 /*yield*/, select(getCurrentGallection)];
            case 2:
                currentGallection = _a.sent();
                gallection = currentSubfolder || currentGallection;
                return [4 /*yield*/, call(setGallectionCover, {
                        gallection: gallection,
                        deviation: deviation,
                    })];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default makeDeviationCurrentGallectionCover;
//# sourceMappingURL=makeDeviationGallectionCover.js.map